<div class="my-content">
  <div class="toolbar-style">
    <mat-toolbar color="accent" class="error-page">
      <span>{{'secure.error_page.no_found_page' | translate}}</span>
      <a mat-button color="primary" (click)="goToHome()">{{'secure.error_page.go_home' | translate}}</a>
    </mat-toolbar>
  </div>
</div>